import skillsSet from '@/routes/SkillsSet';

export default skillsSet;
